import React, { useState } from "react";
import SyncOutlinedIcon from '@mui/icons-material/SyncOutlined';
import RpmReadingsPanel, { useRpmReadings } from "../../landingscreen/patientcharts/tabs/rpm/RpmReadingsPanel";
import api from "../../api/api";
import MailOutlineIcon from '@mui/icons-material/MailOutline';

import { useSelector } from "react-redux";
import ToastMessage from "../../utils/mui/righttoptoast";
import { getPracticeId } from "../../config/practice";
const RpmGraphs = ({selectedCard ,notes ,fetchRpmNote ,tabs,setSelectedTab,selectedTab}) => {
    const [openToast, setOpenToast] = useState(false);
      const [toastMessage, setToastMessage] = useState('');

      const [toastSeverity, setToastSeverity] = useState('success');
  const [bppSyncData, setBppSyncData] = useState([]);
  const practiseid = getPracticeId();

  const [authorize,setAuthorize]=useState(null)
  const rpmscreenprev = useSelector((state) => state.userPrivileges.rpm);
  const handleToastClose = () => {
    setOpenToast(false);
  };

  // Same readings, chart and history as Dashboard -> Chart -> RPM
  // (landingscreen/patientcharts/tabs/rpm/RpmReadingsPanel.jsx).
  const { rpmData, wlmData, isLoading, reloadBpp } = useRpmReadings(selectedCard?.patientid);

  // The panel's sub-tabs (0 BP, 1 Pulse, 2 Weight) drive the card's
  // selectedTab (0 bpp, 1 wlm), which picks the category for
  // Mark as Reviewed / Follow-Up / Call Back.
  const [subTab, setSubTab] = useState(selectedTab === 1 ? 2 : 0);
  const handleSubTabChange = (value) => {
    setSubTab(value);
    if (setSelectedTab) setSelectedTab(value === 2 ? 1 : 0);
  };

  const fetchBppSync = async (selectedCard) => {
    try {
      const payload = {
        OmronAPI: false,
        measurementCount: 0
      };
      const response = await api.post(`/v1/${practiseid}/patient/${selectedCard.patientid}/rpm/bpp-sync`, payload);
      if (response.status === 200) {
        setBppSyncData(response.data); // Set the state with the fetched data
        // The api interceptor returns the body. "New Readings" = the sync ran; anything else is the
        // backend saying why it did not (no device / authorization expired / Omron down / the Omron
        // account is also on another patient's chart) and must not look like a success.
        if (response.message === 'New Readings') {
          const skipped = Number(response?.sharedaccountskipped || 0);
          setToastMessage(`Refresh Successful: ${response?.measurementcount ?? 0} new reading(s)` +
            (skipped ? ` (${skipped} skipped: already on another patient's chart)` : ''));
          setToastSeverity(skipped ? 'warning' : 'success');
        } else {
          setToastMessage(response?.message || 'Sync did not run');
          setToastSeverity('warning');
        }
        setOpenToast(true);
        reloadBpp()
      } else {
        setBppSyncData([]); // Reset data if the response is not 200
      }
    } catch (error) {
      console.log('Error fetching data:', error);
      setBppSyncData([]); // Reset data if error occurs
    } finally {
    }
  };

  const fetchAuthorized = async (selectedCard) => {
    try {
      console.log('Fetching data for patient ID:', selectedCard.patientid); // Log the patient ID for debugging
      const response = await api.put(`/v1/${practiseid}/patient/${selectedCard.patientid}/rpm/authorize`);
    // 
      if (response.status === 200) {
        setAuthorize(response.data);
        const redirectUrl = `https://prd-oauth-website.ohiomron.com/connect/authorize?client_id=brainymedcare-api&response_type=code&scope=weight+bloodpressure+openid+offline_access&redirect_uri=https%3A%2F%2Fwapi.brainymed.com%2Fomron&state=${practiseid}_1_${selectedCard.patientid}`;
        window.open(redirectUrl, '_blank');
      } else {
        setAuthorize([]);
      }
    } catch (error) {
      console.log('Error fetching data:', error);
      setAuthorize([]); // If error occurs, reset the notes
    } finally {
    }
  };

  return (
    <div className="w-full flex flex-col gap-4 ">
      <div className="flex justify-between w-full">
      <div className="flex gap-4 block items-center">
      <div className="cursor-pointer  rounded-lg flex items-center gap-1 text-sm text-[#1d2951]" title="Sync readings from the device account" onClick={()=>fetchBppSync(selectedCard)}>
            <SyncOutlinedIcon /> <span>Sync</span>
      </div>
      </div>

      <div className="flex gap-2 items-center">
             <div className='text-xs text-[#6B7280]'><MailOutlineIcon/>{selectedCard.email}</div>
             {rpmscreenprev.includes("Authorize")&& <div >
            <button onClick={()=>fetchAuthorized(selectedCard)} className="px-3 py-2 text-xs font-font1 h-[5vh] rounded-md bg-[#16A34A] text-white">Authorize</button>
            </div>}
      </div>
      </div>

      <div className="flex flex-col h-auto w-full p-3 pr-6 pl-6 mb-10 bg-[white] rounded-xl border-[1.5px] border-gray-200">
        <RpmReadingsPanel
          rpmData={rpmData}
          wlmData={wlmData}
          isLoading={isLoading}
          subTab={subTab}
          onSubTabChange={handleSubTabChange}
        />
      </div>
                   <ToastMessage
                message={toastMessage}
                severity={toastSeverity}
                open={openToast}
                handleClose={handleToastClose}
              />
    </div>
  );
};

export default RpmGraphs;
